export class HttpErrorModel {
  public extensions?: Map<string, unknown>;

  constructor(
    public message: string,
    public statusCode = 0,
    public errorCode = '',
  ) {}

  toString(): string {
    return `[${this.statusCode}] ${this.message}`;
  }

  toObject(): Partial<HttpErrorModel> {
    return structuredClone({
      message: this.message,
      statusCode: this.statusCode,
      errorCode: this.errorCode,
      extensions: this.extensions,
    });
  }

  toJSON(indented = true): string {
    return JSON.stringify(this.toObject(), null, indented ? 2 : 0);
  }
}
